import {
    StyleSheet
} from "react-native";

export default StyleSheet.create({
    imageContainer: {
        position: "relative",
        overflow: "hidden",
        width: 90,
        height: 112.5
    },
    backgroundImage: {
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: 97
    },
    image:{
        width: "100%",
        height: "100%",
        zIndex: 98
    },
    dot:{
        height: 3,
        width: 3
    },
    container: {
        flexDirection: "row"
    },
    contentContainer: {
        flex: 1
    },
    title: {
        flexShrink: 1
    },
    footerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    logo: {
        width: 16,
        height: 16
    }
});
